import React from 'react'

const FooterAddon = ({
  render,
  sectionId,
}: {
  render: (sectionId: string) => React.ReactNode
  sectionId: string
}) => {
  return <>{render(sectionId)}</>
}

export const MemoizedSectionFooterAddon = React.memo(FooterAddon)
